export default __webpack_public_path__ + "static/media/363.9ea5118c.gif";